import React from 'react';
import Hero from '../Hero';
import Spacing from '../Spacing';
import FunFact from '../FunFact';
import About from '../About';
import WhyChose from '../WhyChose';
import Service from '../Service';
import Portfolio from '../Portfolio';
import Button from '../Button';
import SectionHeading from '../SectionHeading';
// import Award from '../Award';
import Accordion from '../Accordion';
import Cta from '../Cta';
import TestimonialSlider from '../Slider/TestimonialSlider';
// import PostCarousel from '../Slider/PostCarousel';
import { pageTitle } from '../../helpers/PageTitle';
const funfactData = [
  {
    title: 'Satisfied Customers',
    number: '284'
  },
  {
    title: 'Energy Projects Completed',
    number: '1,108'
  },
  {
    title: 'Certified Energy Experts',
    number: '28'
  }
];

const whyChoseFeatureData = [
  {
    title: 'Expertise in Renewable Energy Solutions',
    content:
      'Our team comprises highly skilled professionals with extensive experience in renewable energy technologies, ensuring top-tier service and innovative solutions.',
  },
  {
    title: 'Commitment to Sustainability',
    content:
      'We are dedicated to promoting sustainable practices, helping reduce carbon footprints with energy solutions that not only save money but also protect the planet.',
  },
  {
    title: 'Advanced Energy Management Systems',
    content:
      'Leverage our cutting-edge energy management systems designed to optimize your energy usage and increase efficiency, all tailored to your specific needs.',
  },
  {
    title: 'Customized Solar Solutions',
    content:
      'We provide tailored solar energy solutions that are optimized for your unique geographical and structural conditions, maximizing energy production and cost savings.',
  },
  {
    title: '24/7 Monitoring and Support',
    content:
      'Our dedicated support team offers round-the-clock monitoring and maintenance, ensuring your energy systems operate flawlessly and efficiently at all times.',
  },
  {
    title: 'Innovative Financing Options',
    content:
      'We offer flexible financing solutions that make renewable energy accessible to all. Our programs are designed to minimize upfront costs and maximize your return on investment.',
  },
];

const serviceListData = [
  {
    title: 'Installation Services',
    subtitle:
      'Expert installation of renewable energy systems, including solar panels and wind turbines, ensuring optimal setup and energy efficiency.',
    imgUrl: '/images/renewable-energy/service_installation.jpeg',
    href: '/service/installation-services',
  },
  {
    title: 'Product Sales',
    subtitle:
      'High-quality renewable energy products from top manufacturers. We offer solar panels, batteries, inverters, and more to meet all your energy needs.',
    imgUrl: '/images/renewable-energy/service_product_sales.jpeg',
    href: '/service/product-sales',
  },
  {
    title: 'Site Assessments and Energy Audits',
    subtitle:
      'Comprehensive site assessments and detailed energy audits to identify the best renewable energy solutions tailored to your site\'s unique characteristics.',
    imgUrl: '/images/renewable-energy/service_site_assessments.jpeg',
    href: '/service/site-assessments-energy-audits',
  },
  {
    title: 'After Sales Support',
    subtitle:
      'Dedicated support for all our renewable energy products and services, ensuring long-term efficiency and quick resolution of any issues.',
    imgUrl: '/images/renewable-energy/service_after_sales_support.jpeg',
    href: '/service/after-sales',
  },
  {
    title: 'Financing Options',
    subtitle:
      'We offer flexible financing solutions to make renewable energy accessible to all. Our programs are designed to minimize upfront costs and maximize your return on investment.',
    imgUrl: '/images/renewable-energy/service_financing_options.jpeg',
    href: '/service/financing-options',
  },
];

const portfolioData = [
  {
    href: '/portfolio/portfolio-1',
    imgUrl: '/images/portfolio/home-installation-4.jpg',
    title: 'Solar Flood Light Installation - Karen Residence',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-2',
    imgUrl: '/images/portfolio/public-school-install-4.jpg',
    title: 'Solar Power System - Maragua Public School',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-3',
    imgUrl: '/images/portfolio/street-light-3.jpg',
    title: 'Solar Street Lighting - Kiambu County',
    btnText: 'View Project',
  },
  {
    href: '/portfolio/portfolio-4',
    imgUrl: '/images/portfolio/irrigation-3.jpg',
    title: 'Solar-Powered Irrigation - Mwea Rice Fields',
    btnText: 'View Project',
  },
];
// const awardData = [
//   {
//     brand: 'Behance',
//     title: 'UI/UX design of the month',
//     subTitle:
//       'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
//     date: 'December 12, 2023',
//     awardImgUrl: '/images/creative-agency/award_img_1.svg',
//   },
//   {
//     brand: 'Awwwards',
//     title: 'CSS awards design',
//     subTitle:
//       'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
//     date: 'January 05, 2022',
//     awardImgUrl: '/images/creative-agency/award_img_2.svg',
//   },
//   {
//     brand: 'Google',
//     title: 'Website of the day',
//     subTitle:
//       'Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores',
//     date: 'March 20, 2021',
//     awardImgUrl: '/images/creative-agency/award_img_3.svg',
//   },
// ];
const testimonialData = [
  {
    text: "Soketry Solutions installed solar panels at my home in Kamakis, and the results have been remarkable. Our electricity bills have dropped significantly, and the installation process was smooth and professional. Highly recommend their services for anyone looking to save on energy costs.",
    avatarName: 'John Munyi',
    avatarDesignation: 'Homeowner in Kamakis',
  },
  {
    text: "I turned to Soketry Solutions for a solar installation at my residence in Joska, and I couldn't be happier with the outcome. The team was efficient, respectful, and very knowledgeable. The system has been working flawlessly, and their after-sales support is commendable.",
    avatarName: 'Otieno Nobert',
    avatarDesignation: 'Homeowner in Joska',
  },
  {
    text: "After installing a wind turbine system through Soketry Solutions, my property in Kikuyu has seen a dramatic reduction in carbon footprint. Their team offered tailored solutions that matched my energy needs perfectly. Great service and follow-up.",
    avatarName: 'Agnes Wanjiku',
    avatarDesignation: 'Homeowner in Kikuyu',
  },
  {
    text: "Our company partnered with Soketry Solutions for a large-scale solar power project. Their expertise in renewable energy solutions helped us achieve our sustainability goals with remarkable efficiency. They are true leaders in the industry.",
    avatarName: 'Samantha Kioko',
    avatarDesignation: 'Director at Wellforce Drilling Company',
  },
  {
    text: "As a tech company, we needed a reliable and efficient energy solution, and Soketry Solutions delivered beyond our expectations with their cutting-edge solar technology. Their professional approach and commitment to sustainability are impressive.",
    avatarName: 'Lucas Mwangi',
    avatarDesignation: 'CTO at Innovate Tech',
  },
  {
    text: "Soketry Solutions outfitted our manufacturing facility with a customized solar system that has significantly reduced our energy costs and increased our operational efficiency. Their team's expertise and attention to detail made all the difference.",
    avatarName: 'Esther Njeri',
    avatarDesignation: 'Operations Director at Fabrica Manufacturing',
  },
];

const faqData = [
  {
    title: '01. Why choose Soketry Solutions for renewable energy needs?',
    content:
      'Soketry Solutions stands out in the renewable energy sector with our commitment to sustainable practices, cutting-edge technology, and comprehensive solutions. We offer a unique blend of innovation, reliability, and customer-centric services that ensure optimal energy efficiency and long-term cost savings.',
  },
  {
    title: '02. What types of renewable energy products does Soketry Solutions offer?',
    content:
      'We provide a diverse range of renewable energy products including solar panels, wind turbines, solar water heaters, and energy storage solutions. Our products are suitable for various applications, from residential to commercial and industrial setups, ensuring versatility and scalability.',
  },
  {
    title: '03. How does Soketry Solutions ensure the quality of its installations?',
    content:
      'Our quality assurance comes from using only certified, high-quality materials, partnering with leading manufacturers, and adhering to strict installation standards. Our team of experts performs rigorous testing and quality checks to ensure every installation meets our high standards of efficiency and durability.',
  },
  {
    title: '04. Can Soketry Solutions provide customized energy solutions?',
    content:
      'Absolutely. We specialize in designing customized energy solutions tailored to the specific needs and constraints of our clients. From initial assessments and energy audits to system design and implementation, we ensure that each solution maximizes energy efficiency and cost-effectiveness.',
  },
  {
    title: '05. What financing options are available through Soketry Solutions?',
    content:
      'Soketry Solutions offers various financing options to make renewable energy accessible to all. This includes straightforward purchases, leases, and power purchase agreements (PPAs), each designed to accommodate different budgeting needs and financial circumstances.',
  },
  {
    title: '06. How does Soketry Solutions support clients after installation?',
    content:
      'Our after-sales support includes comprehensive maintenance, monitoring, and repair services to ensure your energy systems operate flawlessly. We also provide warranty service and have a dedicated helpdesk available for any queries or issues, ensuring peace of mind and satisfaction for all our clients.',
  },
];

// const postData = [
//   {
//     thumbnailSrc: '/images/creative-agency/post_1.jpeg',
//     title: 'The True Cost of Solar: Why Initial Investment Leads to Long-Term Savings',
//     date: '15 Jun 2024',
//     url: '/blog/blog-1',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_2.jpeg',
//     title: 'Smart Home Integration: Maximizing Your Solar Investment',
//     date: '17 Jul 2024',
//     url: '/blog/blog-2',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_3.jpeg',
//     title: 'Commercial Solar Success Stories: ROI in Action',
//     date: '20 Aug 2024',
//     url: '/blog/blog-3',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_4.jpeg',
//     title: 'Wind Energy Solutions: Powering Business Growth',
//     date: '22 Sep 2024',
//     url: '/blog/blog-4',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_1.jpeg',
//     title: 'Energy Storage: The Missing Link in Renewable Power',
//     date: '24 Oct 2024',
//     url: '/blog/blog-5',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_2.jpeg',
//     title: '2024 Government Incentives: Your Complete Guide to Renewable Energy Savings',
//     date: '26 Nov 2024',
//     url: '/blog/blog-6',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_3.jpeg',
//     title: '10 Practical Steps to a More Sustainable Lifestyle',
//     date: '28 Dec 2024',
//     url: '/blog/blog-7',
//   },
//   {
//     thumbnailSrc: '/images/creative-agency/post_4.jpeg',
//     title: 'The Future of Renewable Energy: 2025 and Beyond',
//     date: '30 Jan 2024',
//     url: '/blog/blog-8',
//   },
// ];

export default function Home() {
  pageTitle('Soketry Solutions');
  return (
    <>
      <Hero
        title={[
          'Leading Renewable Energy Provider',
          'Over five years of Expertise',
          'Global Impact Initiatives',
          'Empowering Sustainable Futures',
        ]}
        subtitle="Innovative and sustainable energy solutions for a greener planet."
        videoSrc="https://www.youtube.com/watch?v=HJYEKrIRGNE"
        bgUrl="/images/solar-home.jpg"
      />
      <Spacing lg="125" md="70" />
      <div className="container">
        <FunFact data={funfactData} />
      </div>
      <Spacing lg="125" md="70" />
      <About
        thumbnail="/images/creative-agency/about_1.jpg"
        uperTitle="Who We Are"
        title="Pioneers in Renewable Energy"
        subTitle="At Soketry Solutions, we are dedicated to harnessing the power of natural resources to provide renewable energy solutions. Our mission is to drive the transition to renewable energy globally, offering both products and full-scale installation services."
        featureList={[
          'Solar Energy Solutions',
          'Wind Energy Implementation',
          'Geo-thermal Power Systems',
        ]}
        btnText="Learn More"
        btnUrl="/about"
      />
      <Spacing lg="185" md="75" />
      <WhyChose
        sectionTitle="Trusted by Thousands"
        sectionSubTitle="Why Choose Us"
        whyChoseFeatureData={whyChoseFeatureData}
        thumbnailSrc="/images/why-choose-us/why-choose-us-1.jpg"
      />
      <Spacing lg="150" md="80" />
      <section className="cs_primary_bg">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading
            title="Our Core Services"
            subTitle="Services"
            variantColor="cs_white_color"
          />
          <Spacing lg="45" md="30" />
        </div>
        <div className="container">
          <Service
            sectionTitle="Our Core Services"
            sectionSubTitle="Services"
            data={serviceListData}
          />
          <Spacing lg="135" md="65" />
        </div>
      </section>
      <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Highlighted Projects" subTitle="Portfolio" />
          <Spacing lg="85" md="45" />
          <Portfolio data={portfolioData} />
          <Spacing lg="26" md="30" />
          <div className="text-center">
            <Button btnText="See All Projects" btnUrl="/portfolio" />
          </div>
        </div>
        <Spacing lg="150" md="80" />
      </section>
      <section className="cs_primary_bg cs_shape_animation_2">
        <Spacing lg="143" md="75" />
        <div className="cs_shape_1 position-absolute">
          <svg
            width={65}
            height={64}
            viewBox="0 0 65 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* SVG content remains the same */}
          </svg>
        </div>
        <div className="container">
          <SectionHeading
            title="What Our Clients Say"
            subTitle="Testimonials"
            variantColor="cs_white_color"
          />
          <Spacing lg="85" md="20" />
          {/* <Award data={awardData} /> */}
        </div>
        <Spacing lg="75" md="20" />
      </section>
      <TestimonialSlider
        layeredImages={[
          '/images/creative-agency/layer_img_1.png',
          '/images/creative-agency/layer_img_1.png',
          '/images/creative-agency/layer_img_1.png',
          '/images/creative-agency/layer_img_1.png',
          '/images/creative-agency/layer_img_1.png',
        ]}
        data={testimonialData}
      />
      <section>
        <div className="container">
          <Cta
            title="Ready to embrace clean energy? Talk to us today!"
            btnText="Contact Us"
            btnUrl="/contact"
            bgUrl="/images/creative-agency/cta_bg.jpeg"
          />
        </div>
      </section>
      {/* Blog Section Commented Out
      <section className="cs_p76_full_width">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Latest Insights" subTitle="Our Blog" />
          <Spacing lg="85" md="45" />
        </div>
      </section>
      */}
      <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Common Questions" subTitle="FAQs" />
          <Spacing lg="55" md="30" />
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <Accordion variant="cs_type_1" data={faqData} />
            </div>
          </div>
        </div>
        <Spacing lg="120" md="50" />
      </section>
    </>
  );
}
